export const dataColours = ["#722E85", "#CD65D9", "#3ED4B0", "#F54E7B", "#FF7676", "#FAD57A", "#313345", "#b4b2bc"];
